import { Route, Redirect, RouteProps } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'

interface ProtectedRouteProps extends RouteProps {
  requiredType?: 'parent' | 'child'
}

export default function ProtectedRoute({ requiredType, component: Component, render, ...rest }: ProtectedRouteProps) {
  const { user, loading } = useAuth()

  return (
    <Route
      {...rest}
      render={(props) => {
        if (loading) {
          return (
            <div className="min-h-screen flex items-center justify-center">
              <p className="text-muted-foreground">Loading...</p>
            </div>
          )
        }

        if (!user) {
          return <Redirect to="/login" />
        }

        if (requiredType && user.type !== requiredType) {
          return <Redirect to={user.type === 'parent' ? '/dashboard' : '/practice'} />
        }

        if (Component) {
          return <Component {...props} />
        }

        if (render) {
          return render(props)
        }

        return null
      }}
    />
  )
}
